import * as React from 'react';
import { compose, withHandlers, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { ReportSettings, ReportSettingsChangeHandler } from 'logic/reports/ReportSettings';
import { Select } from 'ui/shared/Select';

export type OwnProps = {
    reportSettings: Readonly<ReportSettings>;
    onChange: ReportSettingsChangeHandler;
};

const RawTimeInterval = ({ interval, handleSelectInterval, t }: RecomposeProps & TranslateProps) =>
    <Select
        id="edit-report-time-interval"
        value={ interval }
        onChange={ handleSelectInterval }
    >
        <option value="600">{ t('WC_REPORT_INTERVAL_MINUTE', { count: 10 }) }</option>
        <option value="900">{ t('WC_REPORT_INTERVAL_MINUTE', { count: 15 }) }</option>
        <option value="1800">{ t('WC_REPORT_INTERVAL_MINUTE', { count: 30 }) }</option>
        <option value="3600">{ t('WC_REPORT_INTERVAL_HOUR', { count: 1 }) }</option>
        <option value="7200">{ t('WC_REPORT_INTERVAL_HOUR', { count: 2 }) }</option>
        <option value="21600">{ t('WC_REPORT_INTERVAL_HOUR', { count: 6 }) }</option>
        <option value="43200">{ t('WC_REPORT_INTERVAL_HOUR', { count: 12 }) }</option>
        <option value="86400">{ t('WC_REPORT_INTERVAL_HOUR', { count: 24 }) }</option>
        <option value="604800">{ t('WC_REPORT_INTERVAL_WEEK', { count: 1 }) }</option>
        <option value="2592000">{ t('WC_REPORT_INTERVAL_MONTH', { count: 1 }) }</option>
    </Select>
;

type RecomposeProps = {
    interval: number;
    handleSelectInterval: React.ChangeEventHandler<HTMLSelectElement>;
};

export const TimeInterval = compose<RecomposeProps & TranslateProps, OwnProps>(
    translate(),
    withProps<Partial<RecomposeProps>, OwnProps>(({ reportSettings }) => ({
        interval: reportSettings.timeInterval,
    })),
    withHandlers<OwnProps, Partial<RecomposeProps>>({
        handleSelectInterval: ({ onChange }) => (e: React.ChangeEvent<HTMLSelectElement>) => {
            const minutes = parseInt(e.currentTarget.value, 10);
            onChange(reportSettings => reportSettings.setTimeInterval(minutes));
        },
    }),
)(RawTimeInterval);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/schedule/TimeInterval.tsx